module.exports = __webpack_public_path__ + "img/_2.a76fffd5.png";